site.hero = {
	init:function() {
		if (!$('body').hasClass('frontpage')) return false;
		if ($('#owl-hero .item').length > 1) {
			site.owl.init('#owl-hero .items', {
				loop: true,
				dots: true,
				nav: true,
				items: 1,
				navText: ["<div class=\"arrow\"></div>", "<div class=\"arrow\"></div>"],
				stopOnHover: true,
				autoplay: true,
				autoplayTimeout: 8000,
				autoplayHoverPause: true,
				animateOut: 'fadeOut',
				animateIn: 'fadeIn',
			});
		}
	}
};

site.inits.push('site.hero.init()');
